import { FluentButton } from 'owa-fluent-v9-shims';
import React from 'react';
import loc from 'owa-localize';
import { observer } from 'owa-mobx-react';
import { termsLink } from 'owa-locstrings/lib/strings/termslink.locstring.json';
import { privacyLink } from 'owa-locstrings/lib/strings/privacylink.locstring.json';
import { mergeStyleSets } from '@fluentui/style-utilities';

const Privacydiv: string = 'https://go.microsoft.com/fwlink/?linkId=521839';
const Termsdiv: string = 'https://www.microsoft.com/en-us/servicesagreement';

const HelpContent = () => {
    const styles = mergeStyleSets({
        helpPaneDiv: {
            marginLeft: '-32px',
            position: 'relative',
            height: '100%',
        },
        miniMavenWidgetHostingDiv: {
            position: 'relative',
            height: '60%',
            width: 330,
        },
        miniMavenWidgetLoading: {
            paddingTop: 200,
        },
        actionsDiv: {
            paddingLeft: 24,
        },
        actions: {
            listStyleType: 'none',
            padding: 0,
        },
        action: {
            fontSize: 13,
            paddingTop: 15,
            cursor: 'pointer',
        },
    });

    return (
        <div className={styles.helpPaneDiv}>
            <div className={styles.actionsDiv}>
                <ul className={styles.actions}>
                    <li>
                        <FluentButton
                            appearance="command"
                            onClick={openPrivacyTab}
                            text={loc(privacyLink)}
                            className={styles.action}
                        />
                    </li>
                    <li>
                        <FluentButton
                            appearance="command"
                            onClick={openTermsTab}
                            text={loc(termsLink)}
                            className={styles.action}
                        />
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default observer(HelpContent, 'HelpContent');

function openPrivacyTab() {
    window.open(Privacydiv, '_blank');
}

function openTermsTab() {
    window.open(Termsdiv, '_blank');
}
